/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Selected_Path_LabelInputs */



/**
* | output |
* | --- |
* | "Selected {tool} path" |
*
* @param {Options_Cli_Selected_Path_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_selected_path_label = /** @type {((inputs: Options_Cli_Selected_Path_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Selected_Path_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Chemin sélectionné pour ${i?.tool}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ausgewählter Pfad ${i?.tool}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Percorso selezionato ${i?.tool}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выбранный путь ${i?.tool}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ruta ${i?.tool} seleccionada`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已选择 ${i?.tool} 路径`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`選択された${i?.tool}パス`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चयनित ${i?.tool} पथ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Caminho ${i?.tool} selecionado`)
	return /** @type {LocalizedString} */ (`Selected ${i?.tool} path`)
});